import { render, staticRenderFns } from "./graph.vue?vue&type=template&id=563f5a56&scoped=true&"
import script from "./graph.component.ts?vue&type=script&lang=ts&"
export * from "./graph.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563f5a56",
  null
  
)

export default component.exports